var React = require('react');

function LevelDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M416 256h704q13 0 22.5 9.5t9.5 23.5v863h192q40 0 58 37t-9 69l-320 384q-18 22-49 22t-49-22l-320-384q-26-31-9-69 18-37 58-37h192V512H576q-14 0-25-11L391 309q-13-14-4-34 9-19 29-19z"}));
}

LevelDown.defaultProps = {"width":"1792","height":"1792","viewBox":"0 0 1792 1792"};

module.exports = LevelDown;

LevelDown.default = LevelDown;
